import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import {
  getCanonicalKnowledgeBasePath,
  getContentBySlug,
  MarkdownArticle,
} from "~/components/content";
import { Shell } from "~/components/site-shell";
import { breadcrumbs, jsonLd, pageUrl, seoHead } from "~/config/seo";

export const Route = createFileRoute("/knowledge-base/$")({
  loader: ({ params }) => {
    const requestedPath = params._splat ?? "";
    const canonicalPath = getCanonicalKnowledgeBasePath(requestedPath);
    if (canonicalPath !== requestedPath)
      throw redirect({
        to: "/knowledge-base/$",
        params: { _splat: canonicalPath },
      });
    const item = getContentBySlug("knowledge-base", canonicalPath);
    if (!item) throw notFound();
    return item;
  },
  head: ({ loaderData, params }) => ({
    ...seoHead({
      title: `${loaderData?.title ?? "Help Centre"} | HostRight`,
      description: loaderData?.description ?? "",
      path: `/knowledge-base/${params._splat ?? ""}`,
      type: "article",
      section: loaderData?.category,
    }),
    scripts: loaderData
      ? [
          jsonLd({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: loaderData.title,
            description: loaderData.description,
            url: pageUrl(`/knowledge-base/${params._splat ?? ""}`),
            ...(loaderData.updated ? { dateModified: loaderData.updated } : {}),
            author: { "@type": "Organization", name: "HostRight" },
            publisher: {
              "@type": "Organization",
              name: "HostRight",
              logo: {
                "@type": "ImageObject",
                url: "https://hostright.de/images/logo.svg",
              },
            },
            image: "https://hostright.de/images/og-default.svg",
          }),
          jsonLd(
            breadcrumbs([
              { name: "Home", path: "/" },
              { name: "Help Centre", path: "/knowledge-base" },
              {
                name: loaderData.title,
                path: `/knowledge-base/${params._splat ?? ""}`,
              },
            ]),
          ),
        ]
      : [],
  }),
  component: () => (
    <Shell>
      <MarkdownArticle item={Route.useLoaderData()} sidebar />
    </Shell>
  ),
});
